import React, {useState, useEffect, createContext} from "react";
import stateMap from "store/stateMap";
import { connect } from 'react-redux';
import ProfileBanner from "component/ProfileBanner";
import api from "api";
import "../../sass/tab/tab.scss";
import Header from "component/Header/Header";
import Footer from "component/Footer/Footer";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Splide, SplideSlide } from '@splidejs/react-splide';
import "./index.scss";
import LoginBox from "component/LoginBox/LoginBox";

const UserContext = createContext({
    profile             : false
});

const PageProfile = connect(stateMap)((props) => {
    const [profile, setProfile]                     = useState(false);
    const location = useLocation();

    const getCurrentPath = () => {
        let lastFragment = location.pathname.split('/').pop();

        switch(lastFragment)
        {
            case 'interest':
            case 'rating':
            case 'update':
            case 'initiative':
            case 'configuration':
            case 'skill':
                return lastFragment;
            default:
                return 'experience';
        }
    }

    useEffect(() => {
        if(!props.auth.user)
        {
            return;
        }
        
        api('/Profile', 'get', {
            
        }, 'Bearer ' + props.auth.token)
            .then((response) => {
                setProfile(response.user);
            })
            .catch((error) => {

            })
    }, [props.auth.user]);

    return (
        <>
            <Header>
                {
                    props.auth.user && profile !== false && <ProfileBanner profile={profile} />
                }
            </Header>
                {
                    props.auth.user ?
                    (
                        <>
                            {
                                profile === false ? <span className="skeleton"></span> :
                                <div className="page-profile-user page-profile">
                                    
                                    {
                                        getCurrentPath() != 'update' &&
                                        <div className="profile-menus">
                                            <div className=" tabs">
                                                <Splide options={{
                                                    autoWidth : true
                                                    ,pagination : false
                                                    ,arrows : false
                                                }}>
                                                    <SplideSlide>
                                                        <div className={'tab ' + (getCurrentPath() == 'experience' ? 'active' : '') }>
                                                            <Link to="./" className="tab-wrapper">Experience</Link>
                                                        </div>
                                                    </SplideSlide>
                                                    <SplideSlide>
                                                        <div className={'tab ' + (getCurrentPath() == 'skill' ? 'active' : '') }>
                                                            <Link to="skill" className="tab-wrapper">Skill</Link>
                                                        </div>
                                                    </SplideSlide>
                                                    <SplideSlide>
                                                        <div className={'tab ' + (getCurrentPath() == 'initiative' ? 'active' : '') }>
                                                            <Link to="initiative" className="tab-wrapper">Initiative & Survey</Link>
                                                        </div>
                                                    </SplideSlide>
                                                    <SplideSlide>
                                                        <div className={'tab ' + (getCurrentPath() == 'interest' ? 'active' : '') }>
                                                            <Link to="interest" className="tab-wrapper">Interest</Link>
                                                        </div>
                                                    </SplideSlide>
                                                    <SplideSlide>
                                                        <div className={'tab ' + (getCurrentPath() == 'rating' ? 'active' : '') }>
                                                            <Link to="rating" className="tab-wrapper">Rating &amp; Review</Link>
                                                        </div>
                                                    </SplideSlide>
                                                    <SplideSlide>
                                                        <div className={'tab ' + (getCurrentPath() == 'configuration' ? 'active' : '') }>
                                                            <Link to="configuration" className="tab-wrapper">Configuration</Link>
                                                        </div>
                                                    </SplideSlide>
                                                </Splide>
                                            </div>
                                        </div>
                                    }
                                    <UserContext.Provider value={{
                                        profile : profile
                                    }}>
                                        <Outlet/>
                                    </UserContext.Provider>
                                </div>
                            }
                        </>
                    ) : 
                    <div className="text-center container">
                        <span className="bold block">Login to see your profile</span>
                        <hr />
                        <div className="mx-auto max-w-640">
                            <LoginBox/>
                        </div>
                    </div>
                }
            <Footer/>
        </>
    )
});

export default PageProfile;

export {UserContext};